var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_position_sync"
  }, [_c('div', {
    staticClass: "sync_content"
  }, [_vm._m(0), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncLoading,
      "disabled": _vm.syncLoading
    },
    on: {
      "click": _vm.confirmSync
    }
  }, [_vm._v(" " + _vm._s(_vm.syncLoading ? $t("xffibe6", "同步中...") : $t("uxu25o6", "手动同步岗位")) + " ")])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h1', [_vm._v($t("izwlbn8", "钉钉岗位数据同步"))]), _c('p', [_vm._v($t("fb1bez10", "从钉钉拉取最新的岗位字典及人员岗位分配关系，并同步至 iWork 系统。"))])]);
}];
export { render, staticRenderFns };